<template>
  <div class="page">
    <Header />
    <div class="container d-flex justify-content-center">
      <div>
        <div class="login-card pt-3" style="border: none">
          <h3 class="font-monospace text-center fw-bolder mb-3">Kazang POS Helpdesk</h3>
          <div class="card-body p-1">
            <h4 class="card-title mb-3 text-dark text-uppercase" style="font-weight: 700">
              <span style="color: #9ccc65">Login</span>
            </h4>

            <form @submit.prevent="submitForm">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" v-model="username" id="username" placeholder="Username"
                  required />
                <label for="username">Username</label>
              </div>

              <div class="form-floating mb-3">
                <input :type="passwordType" class="form-control" v-model="password" id="password" placeholder="Password"
                  required />
                <label for="password">Password</label>
              </div>

              <span class="span" @click="reset">Forgot password?</span>
              <div class="text-center submit-btns">
                <button class="login-btn" :disabled="loading">{{ loading ? "Logging in..." : "Login" }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <p class="text-center mt-5">Powered By <a target="_blank" href="https://chrilantech.com">Chrilan Technology</a></p>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Header from "@/components/layout/utils/Header.vue";
import axios from "axios";

export default {
  components: { Header },
  data() {
    return {
      username: "",
      email: "",
      password: "",
      showPassword: false,
      loading: false,
    };
  },
  computed: {
    passwordType() {
      return this.showPassword ? "text" : "password";
    },
  },
  async beforeMount() {
    this.$utils.showLoading()
    localStorage.removeItem("current_store");
    return this.$store.dispatch('getPreLoginData')
      .finally(() => this.$utils.hideLoading())
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    async submitForm() {
      if (!this.username || !this.password) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please enter both email and password!",
        });
        return;
      }

      try {
        this.loading = true;

        const payload = {
          Username: this.username,
          password: this.password,
        };

        const url = ticketApi + `user/Login`;
        // const url = `https://overflow.pos.co.zm/SubscriptionManager/api/dealer/login`;
        const response = await axios.post(url, payload);

        if (response.status === 200) {
          // if (response.data.Type === "Kazang") {
          await this.$router.push({
            name: "otp",
            path: "/otp",
            query: { user: response.data }
          });
          /* } else {
             Swal.fire({
               title: "Incorrect Account Type",
               text: "Your account type is not Kazang. Would you like to visit the Lytsoft Helpdesk for assistance?",
               icon: "warning",
               showCancelButton: true,
               confirmButtonText: "Yes, go to Helpdesk",
               cancelButtonText: "Cancel",
             }).then((result) => {
               if (result.isConfirmed) {
                 window.location.href = "https://hd.chrilantech.com";
               }
             });
           }*/
        } else {
          throw new Error("Login failed");
        }

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: error.response.data || "Invalid email or password.",
        });
      } finally {
        this.loading = false;
      }
    },
    reset() {
      return Swal.fire({
        title: "Enter your email",
        input: "email",
        icon: "info",
        showCancelButton: true,
        background: '#fff',
        color: '#000',
        confirmButtonText: "Reset Password",
        showLoaderOnConfirm: true,
        preConfirm: async (input) => {
          return this.$store.dispatch('triggerResetPassword', input)
            .then(() => {
              this.$router.push('/ResetView');
              responses.showSuccess('Reset Token has been sent to your Email')
            })
        },
        allowOutsideClick: () => !Swal.isLoading()
      })
    },
  },
};
</script>

<style scoped>
.login-btn {
  background: #1e88e5 !important;
  color: white !important;
  font-weight: 600 !important;
  display: block !important;
  height: 45px !important;
  flex: 1 !important;
}

.submit-btns {
  display: flex !important;
  flex-direction: row !important;
  gap: 10px !important;
}

.login-card {
  padding-left: 10px !important;
  padding-right: 10px !important;
  max-width: 400px !important;
  width: 95vw !important;
  position: relative !important;
}

.span {
  font-size: 14px;
  margin-left: 5px;
  color: #2d79f3;
  font-weight: 500;
  cursor: pointer;
}
</style>
